var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H38V9C38 7.34315 36.6569 6 35 6H13C11.3431 6 10 7.34315 10 9V10ZM8 11V9C8 6.23858 10.2386 4 13 4H35C37.7614 4 40 6.23858 40 9V11C40 11.5523 39.5523 12 39 12H9C8.44772 12 8 11.5523 8 11ZM8 21V15C8 14.4477 8.44772 14 9 14H39C39.5523 14 40 14.4477 40 15V21C40 21.5523 39.5523 22 39 22H9C8.44772 22 8 21.5523 8 21ZM10 20H38V16H10V20ZM12 31V25C12 24.4477 12.4477 24 13 24H43C43.5523 24 44 24.4477 44 25V31C44 31.5523 43.5523 32 43 32H13C12.4477 32 12 31.5523 12 31ZM14 30H42V26H14V30ZM8 37V35C8 34.4477 8.44772 34 9 34H39C39.5523 34 40 34.4477 40 35V37C40 39.7614 37.7614 42 35 42H13C10.2386 42 8 39.7614 8 37ZM10 36V37C10 38.6569 11.3431 40 13 40H35C36.6569 40 38 38.6569 38 37V36H10Z",
    fill: "#55749F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon15);
export default __webpack_public_path__ + "static/media/icon15.3b32c18b40b7adbdc0274c5239d290c1.svg";
export { ForwardRef as ReactComponent };